<template>
  <el-container>
    <!-- 移动端遮罩层 -->
    <div 
      class="mobile-overlay" 
      :class="{ active: isMobileMenuOpen }" 
      @click="closeMobileMenu"
    ></div>
    
    <!-- 侧边功能栏 -->
    <el-aside 
      :width="isCollapse ? '64px' : '200px'"
      :class="{ 'mobile-open': isMobileMenuOpen }"
      class="sidebar"
    >
      <Aside :isCollapse="isCollapse || isMobile" @close-mobile="closeMobileMenu"/>
    </el-aside>
    
    <el-container class="main-container">
      <!-- 头部 -->
      <el-header class="header">
        <!-- 移动端菜单按钮 -->
        <el-button
          v-if="isMobile"
          icon="Menu"
          class="mobile-menu-btn"
          @click="toggleMobileMenu"
          circle
          text
        />
        <!-- PC端折叠按钮 -->
        <el-button
          v-if="!isMobile"
          :icon="isCollapse ? 'Expand' : 'Fold'"
          class="collapse-btn"
          @click="toggleCollapse"
          circle
          text
        />
        <Header/>
      </el-header>
      
      <el-main class="main-content">
        <!-- 内容区域 -->
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "@/components/Header";
import Aside from "@/components/Aside";

export default {
  name: "layout",
  components: {
    Header,
    Aside,
  },
  data() {
    return {
      isCollapse: false,
      isMobile: false,
      isMobileMenuOpen: false
    }
  },
  mounted() {
    // 检测设备宽度
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    checkDevice() {
      const width = window.innerWidth;
      this.isMobile = width < 768;
      // 移动端默认折叠侧边栏
      if (this.isMobile) {
        this.isCollapse = true;
        this.isMobileMenuOpen = false;
      } else {
        this.isCollapse = false;
        this.isMobileMenuOpen = false;
      }
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.el-container {
  height: 100vh;
}

/* 侧边栏样式 */
.sidebar {
  transition: width 0.3s ease, transform 0.3s ease;
  overflow: hidden;
  background: #fff;
  box-shadow: 2px 0 6px rgba(0,0,0,0.05);
}

/* PC端折叠 */
.collapse-btn {
  font-size: 18px;
  border: none;
  margin-right: 15px;
}

/* 头部样式 */
.header {
  height: 56px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 15px;
}

/* 主内容区 */
.main-content {
  padding: 15px;
  background: #f5f7fa;
  overflow-y: auto;
}

.main-container {
  flex: 1;
  overflow: hidden;
}

/* 移动端样式 */
@media screen and (max-width: 767px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 200px !important;
    z-index: 1000;
    transform: translateX(-100%);
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }
  
  .sidebar.mobile-open {
    transform: translateX(0);
  }
  
  .mobile-menu-btn {
    font-size: 20px;
    border: none;
    margin-right: 10px;
    display: block !important;
  }
  
  .collapse-btn {
    display: none !important;
  }
  
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  }
  
  .main-content {
    margin-top: 56px;
    padding: 10px;
  }
}

/* 平板端 */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .sidebar {
    width: 180px !important;
  }
  
  .sidebar.el-aside--collapse {
    width: 64px !important;
  }
  
  .header {
    height: 50px;
  }
  
  .main-content {
    padding: 12px;
  }
}
</style>